import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import CopyFileTaskForm from './forms/copy-file-task-form';
import { copyFileTaskValidationSchema } from './schema.js';

export default function SftpOperationCopyFileNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'SFTP Operation Copy File Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'SFTP Operation Copy File Task',
        defaultLabel: 'SFTP Operation Copy File Task',
      }}
    >
      <CommonNode FormComponent={CopyFileTaskForm} schemaResolver={copyFileTaskValidationSchema} />
    </NodeProvider>
  );
}
